import styled, { css } from "styled-components";
import { theme } from "../theme/lexusTheme";
import { IconWrapper } from "../globals/IconWrapper";
import { getBreakpoint } from "../../../../themes/common";
import { focusStyle } from "../utilities/Focus";

type PillType = {
    isPrimary?: boolean;
    hasIcon?: boolean;
    hasIconRight?: boolean;
    iconOnly?: boolean;
    disabled?: boolean;
    isActive?: boolean;
    isLight?: boolean;
    isSelected?: boolean;
};

export const Text = styled.span.attrs(() => ({
    className: "text-body",
}))<{ isActive?: boolean }>`
    max-width: 50px;
    text-overflow: ellipsis;
    color: ${({ isActive }) => (isActive ? theme.colors.white : theme.colors.platinumDark)} !important;
    white-space: nowrap;
    overflow: hidden;
    @media ${getBreakpoint("up", "lg")} {
        max-width: 125px;
    }
`;

export const Wrapper = styled.button<PillType>`
    display: flex;
    position: relative;
    align-items: center;
    height: 48px;
    margin: ${theme.space[1]}px 0;
    padding: ${theme.space[1]}px ${theme.space[2]}px;
    background: ${({ isActive }) => (isActive ? theme.colors.steel : theme.colors.white)};
    border: 1px solid ${({ isActive }) => (isActive ? theme.colors.steel : theme.colors.brushedSteel)};
    border-radius: 70px;
    cursor: pointer;
    z-index: ${({ isSelected }) => (isSelected ? 1061 : "auto")};

    ${({ isLight, isActive }) =>
        isLight &&
        css`
            color: ${theme.colors.white};
            border: 1px solid ${isActive ? theme.colors.white : theme.colors.brushedSteel};
        `};

    ${({ iconOnly }) =>
        iconOnly &&
        css`
            width: 48px;
            height: 48px;
            padding: 12px;
            border-radius: 50%;
        `};

    ${focusStyle}
    ${IconWrapper} {
        color: ${({ isActive }) => (isActive ? theme.colors.white : theme.colors.platinumDark)};
        ${({ hasIcon }) =>
            hasIcon &&
            css`
                margin-right: ${theme.space[2]}px;
            `};
        ${({ hasIconRight }) =>
            hasIconRight &&
            css`
                margin-left: ${theme.space[2]}px;
            `};
    }

    html[dir="rtl"] & {
        ${IconWrapper} {
            ${({ hasIcon }) =>
                hasIcon &&
                css`
                    margin-left: ${theme.space[2]}px;
                    margin-right: 0;
                `};
            ${({ hasIconRight }) =>
                hasIconRight &&
                css`
                    margin-left: 0;
                    margin-right: ${theme.space[2]}px;
                `};
        }
    }
`;

export const Close = styled.div`
    width: 20px;
    height: 20px;
    color: ${theme.colors.white};
    transition: color 0.24s;
    ${IconWrapper} {
        min-width: 20px;
        margin-top: 2px;
    }
`;
